import React, { useState } from "react";
import { Tooltip } from "reactstrap";

const InputFeedback = (props) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <div>
            <Tooltip
                placement='top'
                target={props.id}
                trigger='focus'
                isOpen={tooltipOpen}
                toggle={toggle}
            >
                {props.feedbackText}
            </Tooltip>
        </div>
    )
}

export default InputFeedback;